import { __extends } from "tslib";
import { Debug } from '@awayjs/core';
import { DisplayObject } from '../display/DisplayObject';
var StaticText = /** @class */ (function (_super) {
    __extends(StaticText, _super);
    function StaticText() {
        var _this = _super.call(this) || this;
        // @todo
        Debug.throwPIR('playerglobals/text/StaticText', 'constructor', '');
        return _this;
    }
    //_symbol: TextSymbol;
    StaticText.prototype.applySymbol = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/StaticText', 'applySymbol', '');
    };
    StaticText.prototype._canHaveTextContent = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/StaticText', '_canHaveTextContent', '');
        return true;
    };
    StaticText.prototype._getTextContent = function () {
        // @todo
        Debug.throwPIR('playerglobals/text/StaticText', '_getTextContent', '');
        return this._textContent;
    };
    Object.defineProperty(StaticText.prototype, "text", {
        get: function () {
            // @todo
            Debug.throwPIR('playerglobals/text/StaticText', 'text', '');
            return this._textContent.plainText;
        },
        enumerable: true,
        configurable: true
    });
    StaticText.classInitializer = null;
    StaticText.classSymbols = null;
    StaticText.instanceSymbols = null;
    return StaticText;
}(DisplayObject));
export { StaticText };
